/**
 * Computes per-path traffic share % among ACTIVE paths for the left list.
 * Inactive paths return 0 (UI shows "N/A" instead).
 *
 * For Media Devoted | Created By Ciro Autiero
 */

import type { BinomDraftPath } from '../../binom-flow-draft.types';

export function pathSharePercents(paths: BinomDraftPath[]): number[] {
  const totalActiveWeight = paths.reduce(
    (sum, p) => (p.active ? sum + Math.max(0, p.weight) : sum),
    0,
  );
  if (totalActiveWeight <= 0) return paths.map(() => 0);
  return paths.map((p) =>
    p.active ? (Math.max(0, p.weight) / totalActiveWeight) * 100 : 0,
  );
}
